module.exports = __webpack_public_path__ + "static/media/yuemeishan_plant.edc11022.png";